import { Component, OnInit } from '@angular/core';
import { PERMISSION_TO_DOWLOAD } from 'src/app/handover-constants';
import { AuthService } from 'src/app/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { DwhoExportDataService } from 'src/app/services/dwho-export-data.service';
import { DwhoPowerBiService } from 'src/app/services/dwho-power-bi.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  title = 'Digital Handover';
  firstname = '';
  lastname = '';
  powerBiUrl = '';
  viewLogout = environment.viewLogout;
  canDownloadFile = false;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    public dialogService: DialogService,
    private dwhoPowerBiService: DwhoPowerBiService
  ) {}

  ngOnInit(): void {
    this.firstname = this.userService.getUserProperties()?.firstname || '';
    this.lastname = this.userService.getUserProperties()?.lastname || '';
    this.canDownloadFile = this.userService.hasPermission(
      PERMISSION_TO_DOWLOAD
    );
    this.obtainPowerBiUrl();
  }

  logout(): void {
    this.authService.logout();
  }
  exportDHOData(): void {
    this.dialogService.openDHOExportDataDialog();
  }

  obtainPowerBiUrl() {
    const managementUnit = this.userService.getManagementUnits().split(',')[0];

    this.dwhoPowerBiService
      .getDwhoPowerBiUrl(managementUnit)
      .subscribe((powerBiUrl) => {
        this.powerBiUrl = powerBiUrl;
      });
  }
}
